import { request } from '@/utils/request'

/**
 * 获取打印准考证列表
 */
// export function getPrintList(params){
//   return request({
//     url: `/examUser/print/${params.pageNum}/${params.pageSize}`,
//     method: 'post',
//     data:params
//   })
// }

/* 打印准考证 */
export function printNTS(params) {
  return request({
    url: `/word/export-word`,
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}
export function getPrintList(params) {
  return request({
    url: `examUser/${params.pageNum}/${params.pageSize}`,
    method: 'post',
    data: params.condition
  })
}

// 开始打印
export function examUserPrintTicketRecord(params) {
  return request({
    url: `examUserPrintTicketRecord/save`,
    method: 'post',
    data: params
  })
}